import { loadScript } from './utilities';
import tags from './tags';

/**
 * DPL Version
 * @type {string}
 */
const version = '4.12.4';

/**
 * DPL Init Configuration object
 */
const config = {
  gaMeasurementId: tags.trackingInfo?.gaId,
  gtmId: tags.trackingInfo?.gtmId,
  business: tags.trackingInfo?.dplBusinessId || 'publishing',
  tapsId: tags.tapsId || '6201',
  typeTag: tags.ttag || '',
  s1sid: tags.s1sid || tags.sid || '',
  experimentId: tags.experimentId || '',
};

/**
 * DPL Script URL
 * @type {string}
 */
const url = `https://s.flocdn.com/@s1/dpl/${version}/dpl-${config.business}.js`;

/**
 * callback function to run after the DPL script has loaded.
 */
const callback = () => {
  window.s1.DPL.init({
    session: {
      business: config.business,
      typeTag: config.typeTag,
      s1sid: config.s1sid,
      experimentId: config.experimentId,
    },
    logging: {
      // isEnabled: true, // OPTIONAL boolean / Defaults to TRUE
      // canLogErrors: true, // OPTIONAL boolean / Defaults to TRUE
      canLogWebVitals: true, // OPTIONAL boolean / Defaults to FALSE
      // canLogPageReady: true, // OPTIONAL boolean / Defaults to TRUE
      canLogDwellTime: true, // OPTIONAL boolean / Defaults to FALSE
      // timingFn: () => 2000, // OPTIONAL
    },
    ga: {
      gaMeasurementId: config.gaMeasurementId,
      gtmId: config.gtmId,
      onPrimaryClientIdReady: (clientId) => {
        console.log(`Synced clientId(${clientId}) and loaded gtmjs using DPL.loadGa`);
        // dataLayer.push({
        //   event: 'VirtualPageview',
        //   virtualUrl: location.href,
        //   page: location.pathname,
        // });
      },
    },
    taps: {
      clientId: config.tapsId, // optional override, default to 6201
      isEnabled: false,
    },
  });
  window.dispatchEvent(new Event('DPLReady'));
};

/**
 * Initialise DPL
 */
const init = () => {
  loadScript(url, callback);
};

export default init;
